import { observable } from 'mobx';
import Client from '../../common/client';
import moment from 'moment';

const CorpListStore = observable({
  loading: false,
  error: null,
  userList: null,
  totalInfo: { user: 0, money: 0, count: 0 },
  useInfoList: null,
  visibleUseInfoPopup: false,
  visibleExcelRegisterFilePopup: false,
  visibleExcelRegisterListPopup: false,
  excelRegisterList: null,
  selectedInfoList: null,
  visibleSelectedInfoPopup: false,
  detailInfo: null,
  detailInfoMode: 'I',
  visibleDetailInfoPopup: false,
  updateUserInfoList: null,
  updateUserLimitInfoList: null,
  visibleUpdateInfoPopup: false,
  visibleCardInfoPopup: false,

  // 법인사용현황
  *getUserList() {
    this.error = null;

    try {
      const { Code: code } = JSON.parse(sessionStorage.getItem('user'));

      const response = yield Client.get(
        `/Cms/CustomerCorp/CustomerCorpSearch/${code}`
      );

      // console.log('CorpListStore > *getUserList response : ', response);

      const userList = response.data;

      // console.log('CorpListStore > *getUserList userList : ', userList);

      if (userList) {
        this.totalInfo = {
          user: userList.length,
          money: userList.reduce(
            (total, data) => (total = total + data.TotCharge),
            0
          ),
          count: userList.reduce(
            (total, data) => (total = total + data.SHCNT),
            0
          ),
        };
        this.userList = userList;
      } else {
        this.error = '법인 사용자가 존재하지 않습니다.';
      }
    } catch (error) {
      console.log(`CorpListStore > *getUserList : ${error.message}`);

      this.error = `CorpListStore > *getUserList : ${error.message}`;
    }
  },

  // 이용내역
  setVisibleUseInfoPopup(visible) {
    // console.log('setVisibleUseInfoPopup : ', visible);
    this.visibleUseInfoPopup = visible;
  },

  *getUseInfoList(customerCode, type, fromDate, toDate) {
    const { Code: code } = JSON.parse(sessionStorage.getItem('user'));

    if (!code || code === '') {
      return { error: true, message: '법인코드를 확인할 수 없습니다.' };
    }

    if (!fromDate) {
      fromDate = moment().add(-3, 'months').format('YYYYMMDD');
    }

    if (!toDate) {
      toDate = moment().add(-1, 'days').format('YYYYMMDD');
    }

    //console.log(customerCode, type, fromDate, toDate);

    try {
      const response = yield Client.post('/Cms/CustomerCorp/CorpUseList/', {
        corpCode: code,
        customerCode: customerCode,
        fromDate: fromDate,
        toDate: toDate,
      });

      // console.log('CorpListStore > *getUseInfoList response : ', response);

      const useInfoList = response.data;

      // console.log('CorpListStore > *getUseInfoList userList : ', useInfoList);

      if (useInfoList.length === 0) {
        return { error: true, message: '이용내역이 없습니다.' };
      } else {
        this.visibleUseInfoPopup = true;
        this.useInfoList = useInfoList;

        return { error: false };
      }
    } catch (error) {
      console.log(`CorpListStore > *getUseInfoList : ${error.message}`);

      return {
        error: true,
        message: `오류가 발생하였습니다.\n${error.message}`,
      };
    }
  },

  // 엑셀 등록
  setVisibleExcelRegisterFilePopup(visible) {
    // console.log('setVisibleExcelRegisterFilePopup : ', visible);
    this.visibleExcelRegisterFilePopup = visible;
  },

  setVisibleExcelRegisterListPopup(visible, excelRegisterList) {
    // console.log('setVisibleExcelRegisterListPopup : ', visible);
    this.visibleExcelRegisterListPopup = visible;
    this.excelRegisterList = excelRegisterList;
  },

  // 법인 해지고객 리스트
  setVisibleSelectedInfoPopup(visible, selectedInfoList) {
    // console.log('setVisibleSelectedInfoPopup : ', visible);
    this.visibleSelectedInfoPopup = visible;
    this.selectedInfoList = selectedInfoList;
  },

  *deleteUserInfo(customerCode) {
    // console.log(customerCode);

    const { Code: code } = JSON.parse(sessionStorage.getItem('user'));

    if (!code || code === '') {
      return { error: true, message: '법인코드를 확인할 수 없습니다.' };
    }

    const hour = new Date().getHours();

    if (hour === 9) {
      return { error: true, message: '서비스 점검시간입니다.(9:00~10:00)' };
    }

    try {
      const response = yield Client.post(
        '/Cms/CustomerCorp/CorpCustomerDelete/',
        {
          customerCode: customerCode,
          staffCode: code,
        }
      );

      // console.log('CorpListStore > *deleteUserInfo response : ', response);

      const result = response.data[0];

      // console.log('CorpListStore > *deleteUserInfo result : ', result);

      if (result.Result !== 'S') {
        return {
          error: true,
          message: result.MSG,
        };
      } else {
        return { error: false };
      }
    } catch (error) {
      console.log(`CorpListStore > *deleteUserInfo : ${error.message}`);

      return {
        error: true,
        message: `오류가 발생하였습니다.\n${error.message}`,
      };
    }
  },

  // 법인 사용자 상세정보
  setVisibleDetailInfoPopup(visible, detailInfo, mode) {
    //console.log('setVisibleDetailInfoPopup : ', visible);
    this.visibleDetailInfoPopup = visible;
    this.detailInfo = detailInfo;
    this.detailInfoMode = mode;
  },

  *getUserInfo(lineNumber) {
    // console.log(lineNumber);
    const CompanyCode = sessionStorage.getItem('companyCode');
    const CorpCode = sessionStorage.getItem('CorporationCode')

    try {
      const response = yield Client.post(
        '/Cms/CustomerCorp/CorpCustomerInfoSearch/',
        {
          lineNumber,
          CompanyCode,
          CorpCode
        }
      );

      // console.log('CorpListStore > *getUserDetailInfo response : ', response);

      const userInfo = response.data[0];

      //console.log('CorpListStore > *getUserDetailInfo userInfo : ', userInfo);

      return userInfo;
    } catch (error) {
      console.log(`CorpListStore > *getUserDetailInfo : ${error.message}`);

      return null;
    }
  },

  // 법인 사용자 등록
  *insertUserInfo(detailInfo) {
    // console.log(detailInfo);

    const { Code: code, Name: name } = JSON.parse(
      sessionStorage.getItem('user')
    );

    
    const CompanyCode = sessionStorage.getItem('companyCode');
    
    //console.log(CompanyCode);

    if (!code || code === '') {
      return { error: true, message: '법인코드를 확인할 수 없습니다.' };
    }

    const hour = new Date().getHours();

    if (hour === 9) {
      return { error: true, message: '서비스 점검시간입니다.(9:00~10:00)' };
    }

    try {
      const response = yield Client.post('/Cms/CustomerCorp/InsertCorpUser/', {
        lineNumber: detailInfo.LineNumber,
        name: detailInfo.Name,
        dong: detailInfo.Dong,
        address: detailInfo.Address,
        corpCode: code,
        corpName: name,
        part: detailInfo.Part,
        duty: detailInfo.Duty,
        useCheckCode: detailInfo.UseCheck,
        maxMoney: detailInfo.UseCheck === 1 ? detailInfo.UseCheckValue : 0,
        maxCount: detailInfo.UseCheck === 2 ? detailInfo.UseCheckValue : 0,
        staffCode: code,
        companyCode: CompanyCode
      });

      //console.log('CorpListStore > *insertUserInfo response : ', response);

      const result = response.data[0];

      //console.log('CorpListStore > *insertUserInfo result : ', result);

      if (result.flag !== 10) {
        return {
          error: true,
          message:
            '등록에 실패하였습니다.\n확인 후 다시 등록해 주시기 바랍니다.',
        };
      } else {
        return { error: false };
      }
    } catch (error) {
      console.log(`CorpListStore > *insertUserInfo : ${error.message}`);

      return {
        error: true,
        message: `오류가 발생하였습니다.\n${error.message}`,
      };
    }
  },

  // 법인 사용자 수정
  *updateUserInfo(detailInfo) {
    // console.log(detailInfo);

    const { Code: code, Name: name } = JSON.parse(
      sessionStorage.getItem('user')
    );

    if (!code || code === '') {
      return { error: true, message: '법인코드를 확인할 수 없습니다.' };
    }

    const hour = new Date().getHours();

    if (hour === 9) {
      return { error: true, message: '서비스 점검시간입니다.(9:00~10:00)' };
    }

    try {
      const response = yield Client.post('/Cms/CustomerCorp/UpdateCorpUser/', {
        customerCode: detailInfo.CustomerCode,
        name: detailInfo.Name,
        dong: detailInfo.Dong,
        address: detailInfo.Address,
        corpCode: code,
        corpName: name,
        part: detailInfo.Part,
        duty: detailInfo.Duty,
        useCheckCode: detailInfo.UseCheck,
        maxMoney: detailInfo.UseCheck === 1 ? detailInfo.UseCheckValue : 0,
        maxCount: detailInfo.UseCheck === 2 ? detailInfo.UseCheckValue : 0,
        staffCode: code
      });

      // console.log('CorpListStore > *updateUserInfo response : ', response);

      const result = response.data[0];

      // console.log('CorpListStore > *updateUserInfo result : ', result);

      if (result.flag === 0) {
        return {
          error: true,
          message: `오류가 발생하였습니다.\n${result.message}`,
        };
      } else if (result.flag === 1) {
        return {
          error: true,
          message: '변경사항이 없습니다.',
        };
      } else {
        return { error: false };
      }
    } catch (error) {
      console.log(`CorpListStore > *updateUserInfo : ${error.message}`);

      return {
        error: true,
        message: `오류가 발생하였습니다.\n${error.message}`,
      };
    }
  },

  // 변경내역
  setVisibleUpdateInfoPopup(visible) {
    // console.log('setVisibleUpdateInfoPopup : ', visible);
    this.visibleUpdateInfoPopup = visible;
  },

  *getUpdateInfoList(customerCode) {
    // console.log(customerCode);

    try {
      let response = yield Client.post('/Cms/CustomerCorp/UpdateUserInfo/', {
        customerCode: customerCode,
      });

      // console.log('CorpListStore > *getUpdateInfoList response : ', response);

      const updateUserInfoList = response.data;

      // console.log(
      //   'CorpListStore > *getUpdateInfoList updateUserInfoList : ',
      //   updateUserInfoList
      // );

      response = yield Client.post('/Cms/CustomerCorp/UpdateUserLimitInfo/', {
        customerCode: customerCode,
      });

      // console.log('CorpListStore > *getUpdateInfoList response : ', response);

      const updateUserLimitInfoList = response.data;

      // console.log(
      //   'CorpListStore > *getUpdateInfoList updateUserLimitInfoList : ',
      //   updateUserLimitInfoList
      // );

      if (
        updateUserInfoList.length === 0 &&
        updateUserLimitInfoList.length === 0
      ) {
        return { error: true, message: '변경내역이 없습니다.' };
      } else {
        this.visibleUpdateInfoPopup = true;
        this.updateUserInfoList = updateUserInfoList;
        this.updateUserLimitInfoList = updateUserLimitInfoList;

        return { error: false };
      }
    } catch (error) {
      console.log(`CorpListStore > *getUpdateInfoList : ${error.message}`);

      return {
        error: true,
        message: `오류가 발생하였습니다.\n${error.message}`,
      };
    }
  },

  // 카드등록
  setVisibleCardInfoPopup(visible) {
    // console.log('setVisibleCardInfoPopup : ', visible);
    this.visibleCardInfoPopup = visible;
  },

  *insertCardInfo(customerCode, corpType, cardInfo) {
    // corpType - 0 : 법인, 1 : 법인사용자
    // console.log(customerCode, corpType, cardInfo);

    const companyCode = sessionStorage.getItem('companyCode');
    const phoneNumber = sessionStorage.getItem('LineNumber');
    const { Code: code } = JSON.parse(sessionStorage.getItem('user'));

    //console.log(companyCode);

    if (!code || code === '') {
      return { error: true, message: '법인코드를 확인할 수 없습니다.' };
    }

    try {
      const response = yield Client.post('/Cms/CustomerCorp/InsertBatchKey/', {
        companyCode: companyCode,
        phoneNumber : phoneNumber,
        corpCode: code,
        customerCode: customerCode,
        corpType: corpType,
        cardNo1: cardInfo.cardNo1,
        cardNo2: cardInfo.cardNo2,
        cardNo3: cardInfo.cardNo3,
        cardNo4: cardInfo.cardNo4,
        expireDate1: cardInfo.expireDate1,
        expireDate2: cardInfo.expireDate2,
        password: cardInfo.password,
        authValue: cardInfo.authValue,
      });

      // console.log('CorpListStore > *insertCardInfo response : ', response);

      var result = response.data[0];

      // console.log('CorpListStore > *insertCardInfo result : ', result);

      if (result.ResultYN) {
        return { error: false, message: result.ResultMessage};
      } else {
        return { error: true, message: result.ResultMessage };
      }

      // return { error: true, message: 'test' };
    } catch (error) {

      return {
        error: true,
        message: `오류가 발생하였습니다.\n${error.message}`,
      };
    }
  },

  // 카드해지
  *deleteCardInfo(customerCode, corpType) {
    // corpType - 0 : 법인, 1 : 법인사용자
    // console.log(customerCode, corpType);

    const { Code: code } = JSON.parse(sessionStorage.getItem('user'));

    if (!code || code === '') {
      return { error: true, message: '법인코드를 확인할 수 없습니다.' };
    }

    try {
      const response = yield Client.post('/Cms/CustomerCorp/DeleteBatchKey/', {
        corpCode: code,
        customerCode: customerCode,
        corpType: corpType,
        paymentState: 0,
      });

      // console.log('CorpListStore > *deleteCardInfo response : ', response);

      const result = response.data[0];

      // console.log('CorpListStore > *deleteCardInfo result : ', result);

      if (result.ResultYN) {
        return { error: false };
      } else {
        return { error: true, message: result.ResultMessage };
      }
    } catch (error) {
      console.log(`CorpListStore > *deleteCardInfo : ${error.message}`);

      return {
        error: true,
        message: `오류가 발생하였습니다.\n${error.message}`,
      };
    }
  },
});

export default CorpListStore;
